module.exports = __webpack_public_path__ + "img/sj02.7912b1bf.png";